export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('INDEX.table_label_evg_sku_fty_scmName') || '工厂名称',
    field: 'scmName',
    minWidth: 230,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_evg_sku_fty_isDefault') || '默认工厂',
    field: 'isDefault',
    minWidth: 70,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'isDefault' }

  },

  {
    title: that.$l('INDEX.table_label_evg_sku_fty_ncNo') || 'NC产品编号',
    field: 'ncNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('INDEX.table_label_evg_sku_fty_price') || '工厂单价',
    field: 'ftyPrice',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'ftyPrice' }
  },

  {
    title: that.$l('INDEX.table_label_evg_sku_fty_buyerName') || '采购人员',
    field: 'buyerName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_evg_sku_fty_leadTime') || '生产周期(天)',
    field: 'ftyLeadTime',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
]
